export function base64ToFile(base64, fileName, contentType = 'image/jpeg') {
  // Dekódujeme base64 řetězec
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  // Vytvoříme Uint8Array z čísel
  const byteArray = new Uint8Array(byteNumbers);
  // Vytvoříme nový objekt File
  return new File([byteArray], fileName, { type: contentType });
}
